import { fetcher } from '@commenda/utils';

type SetChatRoomClosedStatusResponse = {
  chatRoom: { id: string; isClosed: boolean };
};

export async function closeChatRoom(chatRoomId: string, token?: string | null) {
  const res = await fetcher(
    `chatRoom/${chatRoomId}/close`,
    { method: 'POST' },
    token
  );

  return res.json() as Promise<SetChatRoomClosedStatusResponse>;
}

export async function reopenChatRoom(chatRoomId: string, token?: string | null) {
  const res = await fetcher(
    `chatRoom/${chatRoomId}/reopen`,
    { method: 'POST' },
    token
  );

  return res.json() as Promise<SetChatRoomClosedStatusResponse>;
}
